import ReactInputMask from "react-input-mask";

import {
  FormControl,
  FormLabel,
  Input as ChakraInput,
  InputProps as ChakraInputProps,
  FormErrorMessage,
} from "@chakra-ui/react";
import { forwardRef, ForwardRefRenderFunction } from "react";
import { FieldError } from "react-hook-form";

interface Props extends ChakraInputProps {
  name: string;
  mask: string;
  label?: string;
  size?: "lg" | "md" | "sm";
  error?: FieldError;
}

const InputBase: ForwardRefRenderFunction<HTMLInputElement, Props> = (
  { name, mask, label, size = "lg", error, ...rest },
  ref
) => {
  return (
    <FormControl isInvalid={!!error}>
      {label && (
        <FormLabel color="gray.800" fontWeight="bold" htmlFor={name}>
          {label}
        </FormLabel>
      )}

      <ChakraInput
        {...rest}
        ref={ref}
        id={name}
        name={name}
        borderColor="gray.50"
        borderWidth={1}
        focusBorderColor="gray.100"
        bgColor="transparent"
        color="white"
        variant="filled"
        borderRadius={90}
        height={51}
        size={size}
        _hover={{
          bgColor: "transparent",
        }}
        style={{ fontSize: 14 }}
        _placeholder={{ color: "gray.50" }}
        as={ReactInputMask}
        mask={mask}
        maskChar={null}
      />
      {!!error && <FormErrorMessage>{error.message}</FormErrorMessage>}
    </FormControl>
  );
};

export const InputMask = forwardRef(InputBase);
